<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <div class="page-title-left">
          <h4 class="mb-0 page-title">{{ title }}</h4>
          <p class="text-muted mb-0 page-subtitle" v-if="subtitle">{{ subtitle }}</p>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0 page-breadcrumb"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
